import { NavItem } from "@/components/item";
import { MESSAGE } from "icons";

export function Explore() {

    return (
        <NavItem
            icon={MESSAGE}
            title="Helper"
            url="https://archives.everest.7span.work/chat"
            target="__blank"
            external
        />
    );
}